import { Line, mixins } from 'vue-chartjs'
import Chart from 'chart.js'
import { EventBus } from '@/eventBus'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      required: true
    },
    componentOptions: {
      type: Object,
      required: false
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderCustomChart()
    if (this.componentOptions) {
      if (this.componentOptions.fontFamily) {
        Chart.defaults.global.defaultFontFamily = this.componentOptions.fontFamily
      }
      if (this.componentOptions.componentId) {
        console.log(`restartLineChart${this.componentOptions.componentId}`)

        EventBus.$on(`restartLineChart${this.componentOptions.componentId}`,
          () => {
            try {
              console.log('restarting LineChart ' + this.componentOptions.componentId)
              this.renderCustomChart()
            } catch (e) {
              // console.log(e)
            }
          })
      }
    }
  },
  methods: {
    renderCustomChart () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
